import React from 'react'
import PropTypes from 'prop-types'

import { compact } from 'lodash'

import { translate, utils } from 'parking-react-common'

import { parkingLots } from '../redux'

import Panel from '../components/Panel'
import { Column } from '../components/Grid'
import InfoTable from '../components/InfoTable'
import ColorSpot from '../components/ColorSpot'

const ParkingLotBasicInfo = ({ item, t }) => {
    if (!item) {
        return null
    }
    const isStreetParking = parkingLots.isStreet(item)

    const data = compact([
        {
            title : t('Name'),
            value : item.name
        },
        {
            title : t('Type'),
            value : utils.label(`parking-lots.type.${item.type}`)
        },
        {
            title : t('Available Spots'),
            value : item.spots_total
        },
        {
            title : t('Timezone'),
            value : item.timezone
        },
        {
            title : t('Currency'),
            value : item.currency
        },
        {
            title : t('Enabled'),
            value : utils.humanizeBoolean(item.enabled)
        },
        {
            title : t('Published'),
            value : utils.humanizeBoolean(item.published)
        },
        isStreetParking && {
            title : t('Color'),
            value : <ColorSpot color={ item.color } />
        }
    ])

    return (
        <Panel title={ t('Basic Info') } hasTable withDivider>
            <Column span={ 6 }>
                <InfoTable data={ data } />
            </Column>
        </Panel>
    )
}

ParkingLotBasicInfo.propTypes = {
    item: PropTypes.object
}

export default translate()(ParkingLotBasicInfo)
